// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1lb9T","containerItemsCenter":"Skeleton_containerItemsCenter__2AFyv"};